import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

const Inventory = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Grid
        container
        spacing={2}
        sx={[
          { mb: (theme) => theme.spacing(2) },
          { mt: (theme) => theme.spacing(2) },
        ]}
        style={{               
          gridTemplateColumns: "auto 1fr",  
          minWidth: 'calc(100vh)',
          justifyContent: "space-between",
          justifyItems: "stretch"
        }}
      >
        <Grid size={{ xs: 8, md: 8, lg: 12, xl: 12 }}>
          <Grid
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Typography component="h2" variant="h6">
           Inventory
            </Typography>
            <Typography component="span" variant="body1">
              {/* Add your right-aligned text here */}
              Component Menu |
            </Typography>
          </Grid>
 

          {/* <CollapsibleTable /> */}
           <Skeleton variant="rectangular" height={310} />
        </Grid>
      </Grid>
      <Grid 
      >
         <Typography component="h2" variant="h6">
        Inventory
            </Typography>
              <Skeleton variant="rectangular" height={310} />
        {/* <ApprovalAccordion>
          {' '}
          <TabComponent />
        </ApprovalAccordion> */}
      {/* <CollapsibleTable />  */}
      </Grid>
      {/* cards */}
      <Grid
        columns={6}
        sx={[
          { mb: (theme) => theme.spacing(2) },
          { mt: (theme) => theme.spacing(8) },
        ]}
      >
 
         <Grid
        columns={6}
        sx={[
          { mb: (theme) => theme.spacing(2) },
          { mt: (theme) => theme.spacing(8) },
        ]}
      >
        <Typography component="h2" variant="h6" sx={{ mt: 2 }}>
           Inventory
        </Typography>
        <Skeleton variant="rectangular" height={310} />
        </Grid>
      </Grid>
    
    
    </Box> 
  );
};

export default Inventory;
